<template>
  <v-snackbar
    v-model="cookieManageSnackbar"
    :timeout="-1"
    color="surface-light"
    location="top"
    theme="light"
    vertical
  >
    <v-row dense>
      <v-col>
        <v-switch
          v-model="consentAdvertising"
          color="secondary"
          density="compact"
          label="Advertising"
          hide-details
        ></v-switch>
        <span class="text-body-2">
          Advertising cookies are used to track visitors across websites to
          allow publishers to display relevant and engaging advertisements.
        </span>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-switch
          v-model="consentAnalytics"
          color="secondary"
          density="compact"
          label="Analytics"
          hide-details
        ></v-switch>
        <span class="text-body-2">
          Analytics cookies help us understand how visitors engage with our
          website.
        </span>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-switch
          v-model="consentNecessary"
          color="secondary"
          density="compact"
          disabled
          label="Necessary"
          hide-details
        ></v-switch>
        <span class="text-body-2">
          Necessary cookies are essential for the website to function and cannot
          be disabled. These are used for website preferences, logging in, or
          making purchases.
        </span>
      </v-col>
    </v-row>

    <template #actions>
      <v-btn
        class="text-none"
        color="secondary"
        variant="flat"
        @click="applyCookieSettings"
      >
        Save Changes
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useConsentUIOrThrow } from '#root/lib/useConsentUI'

const {
  cookieManageSnackbar,
  consentAdvertising,
  consentAnalytics,
  consentNecessary,
  applyCookieSettings
} = useConsentUIOrThrow()
</script>
